export default "__VITE_ASSET__BpWfD2sk__"